import { render, staticRenderFns } from "./points-redeem-success.vue?vue&type=template&id=6fc23202"
import script from "./points-redeem-success.vue?vue&type=script&lang=js"
export * from "./points-redeem-success.vue?vue&type=script&lang=js"
import style0 from "./points-redeem-success.vue?vue&type=style&index=0&id=6fc23202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports